import { DateFormat, jodaFormatPatternWithLocale } from '@ftr/foundation'
import { LocalTime } from '@js-joda/core'
import { CartTime } from '../store'

// This allows us to keep types consistent between ongoing and finished sessions in e.g forms
export const ONGOING_END_TIME_PROXY = LocalTime.MAX

export const CART_TIME_FORMAT = jodaFormatPatternWithLocale(DateFormat.TimeWithSeconds)

export function formatCartTime(cartTime: CartTime): string {
  return `${cartTime.startTime.format(CART_TIME_FORMAT)} - ${cartTime.endTime === null || cartTime.endTime.equals(ONGOING_END_TIME_PROXY) ? 'Ongoing' : cartTime.endTime.format(CART_TIME_FORMAT)}`
}
